<template>
<div class="gray-400 bgray-650">
    <b-container>
        <b-row class="w-100 py-3 f-90">
            <b-col class="col-12 col-sm-6 col-md-6 pl-0 pl-md-4">
                <div class="">(주)퀀티파이드이에스지 <span class="f-75 fw-300">| copyright {{ year }} QuantifiedESG, Inc. All Rights Reserved</span></div>
            </b-col>
            <b-col class="col-12 col-sm-4 col-md-6 pr-0 pr-md-4">
                <div class="d-flex justify-content-end flex-column flex-md-row">
                    <b-link class="mb-2 mb-md-0 pr-3 footer-link text-right" :href="privacyUrl" target="_blank" rel="noopener"> {{$t('개인정보 처리방침')}}</b-link><span class="d-none d-md-inline-block">|</span>
                    <b-link class="mb-2 mb-md-0 pr-3 pl-3 footer-link text-right" to="/terms_layout"> {{$t('이용약관')}}</b-link><span class="d-none d-md-inline-block">|</span>
                    <!-- 사용처(/reg, /reg/join)가 렌더하는 신청 문의 창을 연다 — 카드 아래 '문의하기'와 같은 창 -->
                    <b-link v-b-modal="inquiryModalId" class="mb-2 mb-md-0 pl-3 footer-link text-right"> {{$t('문의하기')}}</b-link>
                </div>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
// GlobalFooter 사용처는 신청 화면(Register.vue, RegisterJoinRequest.vue)뿐이고 둘 다 RegisterInquiryModal 을 렌더한다
const REGISTER_INQUIRY_MODAL_ID = 'register-inquiry-modal';

export default {
    name: 'GlobalFooter',
    data() {
        return {
            inquiryModalId: REGISTER_INQUIRY_MODAL_ID,
            year: new Date().getFullYear()
        };
    },
    computed: {
        privacyUrl() {
            return this.$i18n.locale === 'ko' ? 'https://qesg.co.kr/terms/privacy_policy/' : 'https://qesg.co.kr/terms/privacy_policy_en/';
        }
    }
};
</script>

<style>
.bottom-line {
    padding-top:3rem;
    height: 4px;
    background-color: var(--gray-500);
}

.footer-link,
.footer-link:hover {
    cursor: pointer;
    color: inherit;
}
</style>
